/**
 * Утилита для работы с Яндекс Метрикой в приложении payment-result.
 */

const METRIKA_ID = import.meta.env.VITE_YANDEX_METRIKA_ID
  ? parseInt(import.meta.env.VITE_YANDEX_METRIKA_ID, 10)
  : 0

let initialized = false

const ORDER_FLOW_GOALS = {
  purchase: {
    payment_success: 'purchase_payment_success',
    payment_fail: 'purchase_payment_fail',
  },
  booking_deposit: {
    payment_success: 'booking_deposit_payment_success',
    payment_fail: 'booking_deposit_payment_fail',
  },
  booking_no_deposit: {
    success_view: 'booking_no_deposit_success_view',
  },
}

const APS_ORDER_BRANCH_PAYMENT_GOALS = {
  set: {
    payment_success: 'aps_order_set_payment_success',
    payment_fail: 'aps_order_set_payment_fail',
  },
  deposit: {
    payment_success: 'aps_order_deposit_payment_success',
    payment_fail: 'aps_order_deposit_payment_fail',
  },
}

const ORDER_FLOW_ALIASES = {
  purchase: 'purchase',
  product: 'purchase',
  purchase_one_product: 'purchase',
  booking_deposit: 'booking_deposit',
  deposit: 'booking_deposit',
  booking_with_prepayment: 'booking_deposit',
  booking_no_deposit: 'booking_no_deposit',
  no_deposit: 'booking_no_deposit',
  booking_no_prepayment: 'booking_no_deposit',
  universal: 'purchase',
}

export function initMetrika() {
  if (initialized || METRIKA_ID <= 0 || typeof window === 'undefined') return
  initialized = true

  ;(function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        ;(m[i].a = m[i].a || []).push(arguments)
      }
    m[i].l = 1 * new Date()
    for (let j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) return
    }
    k = e.createElement(t)
    a = e.getElementsByTagName(t)[0]
    k.async = 1
    k.src = r
    a.parentNode.insertBefore(k, a)
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

  window.ym(METRIKA_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  })
}

export function reachGoal(goal, params) {
  if (METRIKA_ID <= 0 || typeof window === 'undefined' || !window.ym) return
  window.ym(METRIKA_ID, 'reachGoal', goal, params)
}

export function resolveOrderFlow(flowLike) {
  if (!flowLike) return null
  return ORDER_FLOW_ALIASES[flowLike] ?? null
}

export function getOrderFlowGoal(flowLike, step) {
  const flow = resolveOrderFlow(flowLike)
  if (!flow) return null
  return ORDER_FLOW_GOALS[flow]?.[step] ?? null
}

function isApsPaymentContext(params = {}) {
  return Boolean(params.traffic_source || params.universal_app || params.app_name)
}

function resolveApsOrderBranchFromOrderType(orderType) {
  if (!orderType) return null
  if (orderType === 'universal') return 'set'
  if (orderType === 'booking_with_prepayment' || orderType === 'booking_deposit') return 'deposit'
  if (orderType === 'booking_no_prepayment' || orderType === 'booking_no_deposit') return 'no_deposit'
  return null
}

export function reachOrderFlowGoal(flowLike, step, params) {
  if (isApsPaymentContext(params)) {
    const branch = resolveApsOrderBranchFromOrderType(params.order_type || flowLike)
    const branchGoal = branch ? APS_ORDER_BRANCH_PAYMENT_GOALS[branch]?.[step] : null
    if (branchGoal) {
      reachGoal(branchGoal, params)
      return
    }
  }

  const goal = getOrderFlowGoal(flowLike, step)
  if (!goal) return
  reachGoal(goal, params)
}

export const metrikaId = METRIKA_ID
